import { Typography } from "@circle-react-shared/uikit/Typography";

import type { TitleProps } from "./types";

export const ConfirmationPage = ({
  prefix,
  oldTitle,
  title,
  suffix,
}: TitleProps) => (
  <span className="inline-flex items-baseline whitespace-nowrap">
    {prefix && (
      <span className="pr-1">
        <Typography.BodySm as="span" weight="normal">
          {prefix}
        </Typography.BodySm>
      </span>
    )}
    <span className="inline-flex items-center align-middle">
      {oldTitle && (
        <Typography.LabelXxs weight="normal">
          <span
            className="text-tertiary pr-1 line-through"
            data-testid="old-price"
          >
            {oldTitle}
          </span>
        </Typography.LabelXxs>
      )}
      <Typography.LabelSm weight="semibold" data-testid="current-price">
        {title}
      </Typography.LabelSm>
    </span>
    {suffix && (
      <span className="pl-1">
        <Typography.BodySm as="span" weight="normal">
          {suffix}
        </Typography.BodySm>
      </span>
    )}
  </span>
);
